<template>
<div>
  <div class="headerBox">
    <div class="upArea">
      <div class="leftImage">
        <img :src="headerImageUrl">
      </div>
      <div class="rightText" style="width: 70%">
        <div class="upuser">
          <span>用户名：{{customerInfo.userName}}</span>
        </div>
        <div class="welText">
          欢迎你
        </div>
      </div>
    </div>
    <div class="mainArea">
      <div class="lineRow">
        <div class="col">
          <div>用户ID：</div>
        </div>
        <div class="col">
          <div>{{customerInfo.userNum}}</div>
        </div>
      </div>
      <div class="lineRow">
        <div class="col">
          <div>身份证：</div>
        </div>
        <div class="col">
          <div>{{ customerInfo.status ? "审核通过" : "审核未通过"}}</div>
        </div>
      </div>
      <div class="lineRow">
        <div class="col">
          <div>账户余额：</div>
        </div>
        <div class="col">
          <div>{{customerInfo.banlaceMoney != null? customerInfo.banlaceMoney : 0.00}}</div>
        </div>
      </div>
      <div class="lineRow">
        <div class="col">
          <mt-button plain size="small">立即提现</mt-button>
        </div>
        <div class="col">
          <mt-button plain size="small" @click="logout">退出系统</mt-button>
        </div>
      </div>
    </div>
  </div>
  <div class="menuCls">
    <van-cell v-for="menu in menuList" :key="menu.id" :title="menu.name" is-link v-if="!menu.menuHidden" @click="goto(menu.path)"></van-cell>
  </div>
</div>
</template>

<script>
import {getCustomerInfo} from "../../api/system/sys_user";

export default {
  name: "MenuLayout",
  data(){
    return {
      headerImageUrl: "https://gimg2.baidu.com/image_search/src=http%3A%2F%2Fc-ssl.duitang.com%2Fuploads%2Fitem%2F202005%2F20%2F20200520024521_zkkfs.jpg&refer=http%3A%2F%2Fc-ssl.duitang.com&app=2002&size=f9999,10000&q=a80&n=0&g=0n&fmt=jpeg?sec=1627121853&t=e2720536d1e481921738c667635a5e98",
      customerInfo:{},
    }
  },
  mounted() {
    getCustomerInfo().then(res=>{
      if (res.success){
        this.customerInfo = res.data;
      }
    });
  },
  computed:{
    menuList(){
      let tmpArray = [];
      //console.log(this.$store.state.maintabs.menuList)
      for (let item of this.$store.state.maintabs.menuList){
        //console.log(item)
        for (let children of item.children){
          //console.log(children)
          tmpArray.push(children);
        }
      }
      //console.log(tmpArray)
      return tmpArray;
    }
  },
  methods:{
    goto(value){
      //console.log(value)
      this.$router.push(value);
      this.$emit('hide');
    },
    logout() {
      this.$router.push({path: "/"});
      sessionStorage.clear()
      window.location.reload(); //刷一下可以清空vuex-store
    },
  }
}
</script>

<style lang="scss" scoped>
.headerBox{
  background-color: #f0f0f0;
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  justify-content: center;
  width: 100%;
  min-height: 12rem;
  .upArea{
    width: 100%;
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-around;
    min-height: 4rem;
    font-size: 1rem;
    margin: 0 auto;
    .leftImage{
      width: 20%;
      margin: 10px auto;
      img {
        border-radius: 50%;
        width: 46px;
        height: 46px
      }
    };
    .upuser{
      margin-top: 10%;
    }
    .welText{
      margin-top: 2%;
      text-align: center;
      font-weight: bolder;
    }
  };
  .mainArea{
    display: flex;
    flex-flow: column nowrap;
    justify-content: space-around;
    min-height: 8rem;
    .lineRow{
      width: 100%;
      display: flex;
      flex-flow: row nowrap;
      justify-content: space-around;
      .col{
        width: 45%;
        text-align: left;
        div{
          max-height: 26px;
        }
      }
      .col:first-child{
        text-align: right;
      }
    }
  };

  .menuCls{
    height: 100%;
    margin: 20px;
  }
}
</style>
